import React from 'react';
interface ProgressBarProps {
  progress: number; // 0-100
  className?: string;
}
export function ProgressBar({
  progress,
  className = ''
}: ProgressBarProps) {
  return <div className={`h-2 bg-blue-50 rounded-full overflow-hidden shadow-inner ${className}`} data-id="element-55">
      <div className="h-full bg-blue-400 rounded-full" style={{
      width: `${progress}%`
    }} data-id="element-56" />
    </div>;
}